export default "__VITE_ASSET__DkrZXQJd__"